import type { FilterDefinition } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

export const statusFilter = (): FilterDefinition => ({
  label: i18n.t('banking.payments.data_table.status'),
  type: 'in',
  options: {
    options: [
      { value: 'init', label: i18n.t('banking.payments.statuses.pending') },
      { value: 'in_progress', label: i18n.t('banking.payments.statuses.in_progress') },
      { value: 'rejected', label: i18n.t('banking.payments.statuses.failed') },
      { value: 'done', label: i18n.t('banking.payments.statuses.paid') },
    ],
  },
})
